import { MEDIA_UPLOAD_SERVICE_URL } from 'config';

export const MEDIA_UPLOAD_V1_URL = `${MEDIA_UPLOAD_SERVICE_URL}/api/v1/media-upload`;
